import React from "react";

const year = () => {
  var date = new Date();
  var year = date.getFullYear();
  return year;
};

const FooterPage = () => {
  return <div> &copy; Discountify {year()}</div>;
};

export default FooterPage;
